import type { Band } from '@/lib/assessment/namatAssessment';

/** The Namat scale band's badge colours, shared by the tables and the «مقياس نمط» window (#124). */
export const BAND_STYLE: Record<Band, string> = {
  excellent: 'bg-green-100 text-green-800',
  very_good: 'bg-yellow-100 text-yellow-800',
  good: 'bg-orange-100 text-orange-800',
  needs_improvement: 'bg-red-100 text-red-800',
};
